// import { atticusColors } from "./colors";
import {
  Components,
  PaletteOptions,
  SimplePaletteColorOptions,
} from "@mui/material";
import { grey } from "@mui/material/colors";

// @ts-ignore
// import { getGlobalStyles } from "./globalStyles.js";

const BUTTON_BORDER_RADIUS = 20;

export const getComponents = (palette: PaletteOptions): Components => ({
  MuiButtonGroup: {
    styleOverrides: {
      root: {
        // Border Radius will match Button Border Radius
        borderRadius: BUTTON_BORDER_RADIUS,
        textTransform: "none",
        boxShadow: "none",
        "&:hover": {
          boxShadow:
            "0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)",
          webkitTransition:
            "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;",
          transition:
            "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;",
        },
      },
    },
  },
  MuiButton: {
    styleOverrides: {
      root: {
        backgroundColor: "primary.main",
        borderRadius: BUTTON_BORDER_RADIUS,
        textTransform: "none",
        boxShadow: "none",
        fontSize: 16,
      },
      contained: {
        "&:hover": {
          // @ts-ignore
          backgroundColor: palette?.primary?.light,
          boxShadow: "none",
        },
      },
      containedSecondary: {
        "&:hover": {
          // @ts-ignore
          backgroundColor: palette?.secondary?.light,
          boxShadow: "none",
        },
      },
    },
  },
  MuiIconButton: {
    styleOverrides: {
      root: {
        "&.outlined": {
          // @ts-ignore
          backgroundColor: palette?.primary?.contrastText,
          border: "solid 1px",
          // @ts-ignore
          borderColor: palette?.primary?.main,
          "& .MuiSvgIcon-root": {
            // @ts-ignore
            color: palette?.primary?.main,
          },
          "&:hover": {
            backgroundColor: "#e0e0e0",
          },
        },
        "&.inverse": {
          // @ts-ignore
          backgroundColor: palette?.primary?.main,
          "& .MuiSvgIcon-root": {
            // @ts-ignore
            color: palette?.primary?.contrastText,
          },
          "&:hover": {
            // @ts-ignore
            backgroundColor: palette?.primary?.light,
          },
        },
        "&.inverseSecondary": {
          // @ts-ignore
          backgroundColor: palette?.secondary?.main,
          "& .MuiSvgIcon-root": {
            // @ts-ignore
            color: palette?.secondary?.contrastText,
          },
          "&:hover": {
            // @ts-ignore
            backgroundColor: palette?.secondary?.light,
          },
        },
      },
    },
  },
  MuiAlert: {
    styleOverrides: {
      root: {
        textAlign: "left",
        "&.MuiAlert-standardInfo .MuiAlert-icon": {
          color: palette?.text?.secondary,
        },
      },
      icon: {
        display: "flex",
        alignItems: "center",
        color: palette?.text?.secondary,
      },
      action: {
        display: "flex",
        alignItems: "center",
        "& .MuiButtonBase-root": {
          color: palette?.text?.secondary,
        },
      },
      standardInfo: {
        backgroundColor: (palette?.primary as SimplePaletteColorOptions)?.light,
        color: palette?.text?.secondary,
      },
    },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        "&.Mui-focused fieldset.MuiOutlinedInput-notchedOutline": {
          // @ts-ignore
          borderColor: palette?.secondary?.main,
        },
      },
      input: {
        backgroundColor: palette?.background?.paper,
      },
      inputMultiline: {
        backgroundColor: palette?.background?.paper,
      },
      adornedStart: {
        backgroundColor: palette?.background?.paper,
      },
    },
  },
  MuiInputLabel: {
    styleOverrides: {
      root: {
        "&.Mui-focused": {
          // @ts-ignore
          color: palette?.secondary?.main,
        },
      },
    },
  },
  MuiCheckbox: {
    styleOverrides: {
      root: {
        "&.Mui-checked": {
          // @ts-ignore
          color: palette?.secondary?.main,
        },
      },
    },
  },
  MuiRadio: {
    styleOverrides: {
      root: {
        "&.Mui-checked": {
          // @ts-ignore
          color: palette?.secondary?.main,
        },
      },
    },
  },
  MuiPaper: {
    styleOverrides: {
      outlined: {
        border: "1px solid " + grey[300],
      },
      elevation: {
        boxShadow:
          "0px 2px 4px -1px rgba(116, 135, 164, 0.2), 0px 4px 5px rgba(116, 135, 164, 0.14), 0px 1px 10px rgba(116, 135, 164, 0.12)",
      },
    },
  },
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: 12,
      },
    },
  },
  MuiSwitch: {
    styleOverrides: {
      root: {
        "& .MuiSwitch-switchBase.Mui-checked": {
          // @ts-ignore
          color: palette?.secondary?.main,
        },
        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
          // @ts-ignore
          backgroundColor: palette?.secondary?.main,
        },
      },
    },
  },
});
